import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { createContext, useContext, useMemo } from 'react';
import { text } from '@rexlabs/styling';
export var TextContext = /*#__PURE__*/createContext({});
export var useText = function useText() {
  return useContext(TextContext);
};
var TEXTS = {
  HEADING: text.styles({
    fallback: 'heading.1'
  }),
  HEADING2: text.styles({
    fallback: 'heading.2'
  }),
  HEADING3: text.styles({
    fallback: 'heading.3'
  }),
  HEADING4: text.styles({
    fallback: 'heading.4'
  }),
  BODY: text.styles({
    fallback: 'normal.default'
  }),
  // Maybe rename??
  SMALL: text.styles({
    fallback: 'small.default'
  }),
  LARGE: text.styles({
    fallback: 'large.default'
  }),
  LABEL: text.styles({
    fallback: 'label'
  }),
  LINK: text.styles({
    fallback: 'link.default'
  }),
  LINK_LIGHT: text.styles({
    fallback: 'link.light'
  }),
  BOLD: {
    fontWeight: function fontWeight(_ref) {
      var token = _ref.token;
      return token('typography.weight.bold');
    }
  },
  SEMIBOLD: {
    fontWeight: function fontWeight(_ref2) {
      var token = _ref2.token;
      return token('typography.weight.semibold');
    }
  },
  ITALIC: {
    fontStyle: 'italic'
  },
  GREY: {
    color: function color(_ref3) {
      var token = _ref3.token;
      return token('text.grey.color', token('palette.grey.600', 'grey'));
    }
  }
};

function TextProvider(_ref4) {
  var _ref4$text = _ref4.text,
      text = _ref4$text === void 0 ? {} : _ref4$text,
      props = _objectWithoutProperties(_ref4, ["text"]);

  var memText = useMemo(function () {
    return _objectSpread(_objectSpread({}, TEXTS), text);
  }, [text]);
  return /*#__PURE__*/React.createElement(TextContext.Provider, _extends({
    value: memText
  }, props));
}

export default TextProvider;